import React from "react";
import { useLocation } from "react-router-dom";
import BookingCard from "../BookingCard/BookingCard";

function MyBookings() {
	const location = useLocation();
	let details = {
		Paymentdate: "Booking Date :",
		Paymenttime: "Booking Time :",
		PaymentStatus: "Payment Status :",
		Total: "Total :",
	};

	let payDetails = {
		Paymentdate: "17:30 Am",
		Paymenttime: "29 Dec 22",
		PaymentStatus: "Paid",
		Total: "$50.00",
	};
	return (
		<BookingCard
			mainhead={location?.state?.membership?.heading}
			mainnumber={location?.state?.heading}
			smallhead="Order Detail"
			details={location?.state}
			payDetails={location?.state?.price}
		/>
	);
}

export default MyBookings;
